import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  totalCars: 0,
  searchText: "",
  context: "STOCK_ID",
  workOrderDetails: {},
  partsStatusData: { loading: false },
  editDetails: {
    loading: false
  },
  filters: {
    workflowStatus: [],
    partStatus: []
  },
  columns: [],
  dataSource: [],
  pagination: { pageSize: 20, currentPage: 1 },
  workstations: {}
};

const fetchTableStart = (state) => ({
  ...state,
  loading: true
});

const fetchTableSuccess = (state, action) => ({
  ...state,
  loading: false,
  totalCars: action.data.totalCars,
  workOrderDetails: action.data.dataSource,
  dataSource: action.data.dataSource,
  workstations: action.data.workstations,
  columns: action.data.columns,
  pagination: {
    ...state.pagination,
    pageSize: action.data.pageSize
  }
});
const fetchTableFailure = (state) => ({
  ...state,
  loading: false
});
const fetchWorkOrderPartsStart = (state) => ({
  ...state,
  partsStatusData: {
    loading: true
  }
});

const fetchWorkOrderPartsSuccess = (state, action) => ({
  ...state,
  partsStatusData: { loading: false, details: action.data },
  pagination: {
    ...state.pagination,
    pageSize: action.data.pageSize
  }
});
const fetchWorkOrderPartsFailure = (state) => ({
  ...state,
  partsStatusData: {
    loading: false
  }
});
const editTableStart = (state) => ({
  ...state,
  editDetails: {
    loading: true
  }
});

const editTableSuccess = (state, action) => ({
  ...state,
  editDetails: {
    loading: false,
    details: action.data
  }
});

const editTableFail = (state) => ({
  ...state,
  editDetails: {
    loading: false
  }
});

const setCurrentPage = (state, action) => ({
  ...state,
  pagination: {
    ...state.pagination,
    currentPage: action.data
  }
});
const setPageSize = (state, action) => {
  const {
    totalCars,
    pagination: { currentPage }
  } = state;
  const lastPage = totalCars / action.data;

  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageSize: action.data,
      currentPage: lastPage > currentPage ? currentPage : Math.ceil(lastPage)
    }
  };
};

const setFilters = (state, action) => ({
  ...state,
  filters: {
    ...state.filters,
    [action.filterName]: action.data
  },
  pagination: { ...state.pagination, currentPage: 1 }
});

const updateFilters = (state, action) => ({
  ...state,
  filters: action.data
});

const setSearchText = (state, action) => ({
  ...state,
  searchText: action.val,
  pagination: { ...state.pagination, currentPage: 1 }
});

const resetWorkOrder = (state) => ({
  ...state,
  filters: {
    ...state.filters
  }
});

const setSearchContext = (state, action) => ({
  ...state,
  context: action.value
});

const resetFilters = (state) => ({
  ...state,
  filters: {
    workflowStatus: [],
    partStatus: []
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_WORKORDER_PARTS_START:
      return fetchWorkOrderPartsStart(state, action);

    case actionTypes.FETCH_WORKORDER_PARTS_SUCCESS:
      return fetchWorkOrderPartsSuccess(state, action);

    case actionTypes.FETCH_WORKORDER_PARTS_FAIL:
      return fetchWorkOrderPartsFailure(state, action);

    case actionTypes.FETCH_V2_TABLE_START:
      return fetchTableStart(state, action);

    case actionTypes.FETCH_V2_TABLE_SUCCESS:
      return fetchTableSuccess(state, action);

    case actionTypes.FETCH_V2_TABLE_FAIL:
      return fetchTableFailure(state, action);

    case actionTypes.EDIT_TABLE_START:
      return editTableStart(state, action);

    case actionTypes.EDIT_TABLE_SUCCESS:
      return editTableSuccess(state, action);

    case actionTypes.EDIT_TABLE_FAIL:
      return editTableFail(state, action);

    case actionTypes.SET_WORKORDER_CURRENT_PAGE:
      return setCurrentPage(state, action);

    case actionTypes.SET_WORKORDER_PAGE_SIZE:
      return setPageSize(state, action);

    case actionTypes.SET_V2_FILTERS:
      return setFilters(state, action);

    case actionTypes.UPDATE_FILTERS:
      return updateFilters(state, action);

    case actionTypes.SET_WORKORDER_SEARCH:
      return setSearchText(state, action);

    case actionTypes.RESET_WORK_ORDER:
      return resetWorkOrder(state);

    case actionTypes.SET_SEARCH_CONTEXT:
      return setSearchContext(state, action);

    case actionTypes.RESET_FILTERS:
      return resetFilters(state);
    default:
      return state;
  }
};

export default reducer;
